<template>
  <generic-modal :title="$t('neolink request')" ref="generic_modal">
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('profile')"
              :placeholder="$t('profile')"
              url="/neolink/profile/catalog"
              name_field="name"
              value_field="profile_id"
              @selected="set_profile"
              ref="profile_dropdown"
              :is_multiple="false"
            />
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("internal code") }}</label>
            <div class="control">
              <input type="text" class="input" v-model="meta.internal_code" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("internal name") }}</label>
            <div class="control">
              <input type="text" class="input" v-model="meta.internal_name" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("title") }}</label>
            <div class="control">
              <input type="text" class="input" v-model="meta.title" />
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("quotas") }}</label>
            <div class="select">
              <select v-model="meta.quotas">
                <option
                  :value="quota.code"
                  v-for="(quota, qidx) in quotas"
                  :key="qidx"
                >
                  {{ $t(quota.name) }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("quota") }}</label>
            <div class="control">
              <input type="text" class="input" v-model="meta.quota" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('social networks')"
              :placeholder="$t('social networks')"
              url="/neolink/profile/catalog"
              name_field="name"
              value_field="profile_id"
              @selected="set_social_networks"
              ref="social_networks_dropdown"
              :is_multiple="true"
            />
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("description") }}</label>
            <div class="control">
              <textarea
                rows="2"
                class="textarea"
                v-model="meta.description"
                :placeholder="$t('description')"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-search"></i>
        </span>
        <span>{{ $t("search") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import { put, post, generate_error_message_text, get } from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import quotas from "../../../quotas.json";

export default {
  name: "NeolinkRequestModal",
  components: {
    GenericModal,
    GenericDropdown,
  },
  props: {},
  data() {
    return {
      meta: {},
      error: "",
      quotas,
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return (
        !v.meta.profile_id ||
        !v.meta.internal_code ||
        !v.meta.internal_name ||
        !v.meta.title ||
        !v.meta.quotas ||
        !v.meta.quota ||
        // !v.meta.social_networks ||
        !v.meta.description
      );
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let data = { ...v.meta };
      put("/neolink/request", data)
        .then(() => {
          // console.log("request created");
          v.$emit("success");
          v.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {};
      v.error = "";
      v.$refs.profile_dropdown.clear();
    },
    set_profile(profile) {
      if (profile) {
        let v = this;
        v.meta.profile_id = profile.profile_id;
      }
    },
    set_social_networks(social_networks) {
      console.log(social_networks);
      // if (social_networks) {
      //   let v = this;
      //   v.meta.social_networks = social_networks.map((sn) => sn.profile_id);
      // }
    },
  },
  mounted() {},
  created() {},
  watch: {},
};
</script>
<style></style>
